// components
// ----------------------------------------------------------------------

import Iconify from "../Iconify";

// Define more types here
const FORMAT_PDF = ['pdf'];
const FORMAT_TEXT = ['txt'];
const FORMAT_PHOTOSHOP = ['psd'];
const FORMAT_WORD = ['doc', 'docx'];
const FORMAT_EXCEL = ['xls', 'xlsx'];
const FORMAT_ZIP = ['zip', 'rar', 'iso'];
const FORMAT_ILLUSTRATOR = ['ai', 'esp'];
const FORMAT_POWERPOINT = ['ppt', 'pptx'];
const FORMAT_AUDIO = ['wav', 'aif', 'mp3', 'aac'];
const FORMAT_IMG = ['jpg', 'jpeg', 'gif', 'bmp', 'png', 'svg'];
const FORMAT_VIDEO = ['m4v', 'avi', 'mpg', 'mp4', 'webm'];

const iconUrl = (icon) => `/assets/icons/files/${icon}.svg`;

// ----------------------------------------------------------------------

export function fileFormat(fileUrl) {
  let format;

  const fileType = fileTypeByUrl(fileUrl);

  switch (true) {
    case FORMAT_TEXT.includes(fileType):
      format = 'txt';
      break;
    case FORMAT_ZIP.includes(fileType):
      format = 'zip';
      break;
    case FORMAT_AUDIO.includes(fileType):
      format = 'audio';
      break;
    case FORMAT_IMG.includes(fileType):
      format = 'image';
      break;
    case FORMAT_VIDEO.includes(fileType):
      format = 'video';
      break;
    case FORMAT_WORD.includes(fileType):
      format = 'word';
      break;
    case FORMAT_EXCEL.includes(fileType):
      format = 'excel';
      break;
    case FORMAT_POWERPOINT.includes(fileType):
      format = 'powerpoint';
      break;
    case FORMAT_PDF.includes(fileType):
      format = 'pdf';
      break;
    case FORMAT_PHOTOSHOP.includes(fileType):
      format = 'photoshop';
      break;
    case FORMAT_ILLUSTRATOR.includes(fileType):
      format = 'illustrator';
      break;
    default:
      format = fileType;
  }

  return format;
}

// ----------------------------------------------------------------------

export function fileThumb(fileUrl) {
  let thumb;

  switch (fileFormat(fileUrl)) {
    case 'folder':
      thumb = <Iconify icon={'flat-color-icons:folder'} width={32} height={32} />;
      break;
    case 'txt':
      thumb = <Iconify icon={'vscode-icons:file-type-text'} width={32} height={32} />;
      break;
    case 'zip':
      thumb = <Iconify icon={'vscode-icons:file-type-zip'} width={32} height={32} />;
      break;
    case 'audio':
      thumb = <Iconify icon={'vscode-icons:file-type-audio'} width={32} height={32} />;
      break;
    case 'video':
      thumb = <Iconify icon={'vscode-icons:file-type-video'} width={32} height={32} />;
      break;
    case 'word':
      thumb = <Iconify icon={'vscode-icons:file-type-word'} width={32} height={32} />;
      break;
    case 'excel':
      thumb = <Iconify icon={'vscode-icons:file-type-excel'} width={32} height={32} />;
      break;
    case 'powerpoint':
      thumb = <Iconify icon={'tvscode-icons:file-type-powerpoint2'} width={32} height={32} />;
      break;
    case 'pdf':
      thumb = <Iconify icon={'vscode-icons:file-type-pdf2'} width={32} height={32} />;
      break;
    case 'photoshop':
      thumb = <Iconify icon={'skill-icons:photoshop'} width={32} height={32} />;
      break;
    case 'illustrator':
      thumb = <Iconify icon={'skill-icons:illustrator'} width={32} height={32} />;
      break;
    case 'image':
      thumb = <Iconify icon={'flat-color-icons:image-file'} width={32} height={32} />;
      break;
    default:
      thumb = <Iconify icon={'flat-color-icons:file'} width={32} height={32} />;
  }
  return thumb;
}

// ----------------------------------------------------------------------

export function fileTypeByUrl(fileUrl = '') {
  return (fileUrl && fileUrl.split('.').pop()) || '';
}

// ----------------------------------------------------------------------

export function fileNameByUrl(fileUrl) {
  return fileUrl.split('/').pop();
}

// ----------------------------------------------------------------------

export function fileData(file) {
  // Url
  if (typeof file === 'string') {
    return {
      key: file,
      preview: file,
      name: fileNameByUrl(file),
      type: fileTypeByUrl(file),
    };
  }

  // File
  return {
    key: file.preview,
    name: file.name,
    size: file.size,
    path: file.path,
    type: file.type,
    preview: file.preview,
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
  };
}
